import { useTranslation } from 'react-i18next';
import { Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shared/ui';
import type { ProductStatus } from '@entities/product';

const STATUSES: ProductStatus[] = ['DRAFT', 'PENDING_MODERATION', 'PUBLISHED', 'REJECTED', 'ARCHIVED'];

interface ProductsFiltersProps {
  status: ProductStatus | undefined;
  q: string;
  onStatusChange: (status: ProductStatus | undefined) => void;
  onQueryChange: (q: string) => void;
}

export function ProductsFilters({ status, q, onStatusChange, onQueryChange }: ProductsFiltersProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Input
        placeholder={t('products.filter.search')}
        value={q}
        onChange={(e) => onQueryChange(e.target.value)}
        className="max-w-xs"
      />
      <Select
        value={status ?? 'ALL'}
        onValueChange={(v) => onStatusChange(v === 'ALL' ? undefined : (v as ProductStatus))}
      >
        <SelectTrigger className="w-48">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="ALL">{t('products.filter.all')}</SelectItem>
          {STATUSES.map((s) => (
            <SelectItem key={s} value={s}>
              {t(`products.status.${s}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
